import AOS from 'aos/dist/aos.js';

// Import bootstrap-select.js;
import 'bootstrap-select/dist/js/bootstrap-select.min';

// Import Slick
import 'slick-carousel/slick/slick.min';

export default {
  init() {
    // JavaScript to be fired on all pages
    $.fn.moveElement = function (origin,target,currentBreakPoint) {
      if (currentBreakPoint === 'medium' || (currentBreakPoint === 'small' || currentBreakPoint === 'xSmall')) {
        this.appendTo(target);
      }
      else {
        this.insertBefore(origin);
      }
    };

    AOS.init({
      disable: 'mobile',
      once: true,
    });

    window.bsBreakpoints = require('bs-breakpoints');

    // Generic Slider block
    $('.generic-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    // Generic carrousel block
    $('.generic-carrousel').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
    });

    // Quiz block
    // Disable form submissions if there are invalid fields
    $('.needs-validation').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.checkValidity()) {
        formValidate(this);
      }
      else {
        var radios_inputs = $('.needs-validation').find('input[type="radio"]:not(:checked)');
        var myInputGroups = [];
        radios_inputs.each(function(){
            var name= $(this).attr('name');
           if (!$('input:radio[name=' + name + ']:checked').length) {
              myInputGroups.push(name);
            }
        });
        $('html, body').animate({ scrollTop: $('.'+myInputGroups[0]).offset().top - $('.header').height() }, 400);
      }
      $(this).addClass('was-validated');
    });

    $('.needs-validation').on('reset', function () {
      formReset(this);
      $(this).removeClass('was-validated');
      $('html, body').animate({ scrollTop: $('.quiz').offset().top - $('.header').height() }, 400);
    });

    // function to check if at least one 
    function checkAtLeastOneYes(form) {
      var result = false;

      if (form.length) {
        var inputs = $(form).find('input[type="radio"]:checked');
        inputs.each(function () {
          if ($(this).val() == 1) {
            result = true;
            return false;
          }
        });
      }

      return result;
    }

    // form validate
    function formValidate(form) {
      $(form).find('.validation').removeClass('d-none');
      $(form).find('input[type="submit"]').addClass('d-none');
      $(form).find('input[type="radio"]').prop('disabled', true);
      if (checkAtLeastOneYes(form)) {
        $(form).find('.validation_1').removeClass('d-none');
        $(form).find('.validation_2').addClass('d-none');
      }
      else {
        $(form).find('.validation_1').addClass('d-none');
        $(form).find('.validation_2').removeClass('d-none');
      }
      $('html, body').animate({ scrollTop: $('.validation').offset().top - $('.header').height() }, 400);
    }

    // form reset
    function formReset(form) {
      $(form).find('input[type="submit"]').removeClass('d-none');
      $(form).find('.validation').addClass('d-none');
      $(form).find('input[type="radio"]').prop('disabled', false);
    }

    function dropdownSmallShow(currentBreakPoint) {
      $('.dropbtn').unbind().on('click', function () {
        if (currentBreakPoint === 'medium' || (currentBreakPoint === 'small' || currentBreakPoint === 'xSmall')) {
          $('.dropdown-content').toggle('show');
        }
      });
    }

    function parentPreventClick(currentBreakPoint) {
      if (currentBreakPoint === 'medium' || (currentBreakPoint === 'small' || currentBreakPoint === 'xSmall')) {
        $('.navbar-nav li:has(ul.dropdown-menu) > a').on('click', function (e) {
          e.preventDefault();
        });
      }
      else {
        $('.navbar-nav li:has(ul.dropdown-menu) > a').on('click',function () {
          window.location.href = $(this).attr('href');
        });
      }
    }

    $(window).on('init.bs.breakpoint', function () {
      var currentBreakPoint = window.bsBreakpoints.detectBreakpoint();
      $('#topNav').moveElement('.navbar', '#primaryNavbar', currentBreakPoint);
      dropdownSmallShow(currentBreakPoint);
      parentPreventClick(currentBreakPoint);
    })
    $(window).on('new.bs.breakpoint', function () {
      var currentBreakPoint = window.bsBreakpoints.detectBreakpoint();
      $('#topNav').moveElement('.navbar', '#primaryNavbar', currentBreakPoint);
      dropdownSmallShow(currentBreakPoint);
      parentPreventClick(currentBreakPoint);
    })

    window.bsBreakpoints.init();
  },
  finalize() {

    $(window).scroll(function () {
			if ($(this).scrollTop() > 50) {
				$('#backToTop').fadeIn();
			} else {
				$('#backToTop').fadeOut();
			}
		});
		// scroll body to 0px on click
		$('#backToTop').click(function () {
			$('body,html').animate({
				scrollTop: 0,
			}, 400);
			return false;
		});

    // JavaScript to be fired on all pages, after page specific JS is fired
    $('[data-toggle="slide-collapse"]').on('click', function () {
      var navMenuCont = $($(this).data('target'));
      navMenuCont.animate({
        'width': 'toggle',
      }, 350);
      $('.menu-overlay').fadeToggle(500);

    });
    $('.menu-overlay').click(function () {
      $('.navbar-toggler').trigger('click');
      $('.menu-overlay').fadeOut(500);
    });

    /**
    * Manage search form displaying.
    */
    $(document).on('click.search.show', '.nav-search:not(".opened")', e => {
      e.preventDefault();

      let $search = $(e.currentTarget).addClass('opened');
      let $contact = $search.next('.nav-contact').addClass('closed');
      let $hidded = $search
        .find('.nav-link span')
        .add($contact.find('.nav-link span'))
        .finish()
        .hide(400);
      let $displayed = $search
        .find('input')
        .finish()
        .show('slow', () => {
          $displayed.focus().on('blur', () => {
            $hidded.show(400);
            $displayed.hide('slow', () => {
              $search.removeClass('opened');
              $contact.removeClass('closed');
            });
          });
        });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js